<template>
  <a
    v-if="!!globals"
    rel="noreferrer"
    target="_blank"
    v-text="globals.contact.email"
    :href="`mailto:${globals.contact.email}`"
  />
</template>

<script>
import { globals } from "@io/global";

export default {
  name: "BlockInstagram",

  computed: {
    globals
  }
};
</script>
